{
    "EnablerptrequestauditLabel": "Audit-uitvoer rapportverzoek inschakelen:",
    "Audit_SectionHeader": "Audit",
    "Audit_SectionPara": "Waarschuwing: Schakel de volgende instelling alleen in wanneer daarom wordt gevraagd door een lid van uw applicatiebeheer- of ondersteuningsteam.",
    "NAME": "Audit"
}